import * as tslib_1 from "tslib";
import { AttachmentFileType } from 'owa-attachment-common';
import { AttachmentConstants } from 'owa-attachment-model-store/lib/utils/attachmentConstants';
import { lazyCreateAttachmentsViaQueueManager } from 'owa-attachment-well-data';
import { lazyCreateAttachmentFileFromExistingMailboxAttachment } from 'owa-attachment-well-data';
export default function createAttachmentsFromRecentAttachments(itemId, attachmentWell, recentAttachments, infoBarAddHandler, infoBarRemoveHandler) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var createAttachmentFileFromAttachmentType, attachmentFiles, cloudFiles, attachmentItemFiles;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyCreateAttachmentFileFromExistingMailboxAttachment.import()];
                case 1:
                    createAttachmentFileFromAttachmentType = _a.sent();
                    attachmentFiles = recentAttachments
                        .filter(function (a) { return !isClassicInlineAttachment(a); })
                        .map(createAttachmentFileFromAttachmentType);
                    cloudFiles = attachmentFiles.filter(function (a) { return a.fileType === AttachmentFileType.Cloud; });
                    attachmentItemFiles = attachmentFiles.filter(function (a) { return a.fileType === AttachmentFileType.AttachmentItem; });
                    attachmentItemFiles.length > 0 &&
                        lazyCreateAttachment(attachmentWell, itemId, attachmentItemFiles, infoBarAddHandler, infoBarRemoveHandler, false /* isInline */, false /* shouldShare */);
                    cloudFiles.length > 0 &&
                        lazyCreateAttachment(attachmentWell, itemId, cloudFiles, infoBarAddHandler, infoBarRemoveHandler, false /* isInline */, true /* shouldShare */);
                    return [2 /*return*/];
            }
        });
    });
}
function isClassicInlineAttachment(attachmentType) {
    return (attachmentType.__type !== AttachmentConstants.attachmentTypes.REFERENCE_ATTACHMENT_TYPE &&
        attachmentType.IsInline);
}
function lazyCreateAttachment(attachmentWell, itemId, attachments, infoBarAddHandler, infoBarRemoveHandler, isInline, shouldShare) {
    lazyCreateAttachmentsViaQueueManager.import().then(function (createAttachmentsViaQueueManager) {
        createAttachmentsViaQueueManager(attachmentWell, itemId, attachments, infoBarAddHandler, infoBarRemoveHandler, isInline, shouldShare);
    });
}
//# sourceMappingURL=createAttachmentsFromRecentAttachments.js.map